'use client';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { CopyableTextComponent } from './components/copyable-text-component';
import * as Styled from './thank-you-mobile.styled';
const LOGO_WIDTH = 70;
const LOGO_HEIGHT = 70;

/**
 * @useClient
 */
export const ThankYouMobile = React.memo(function ThankYouMobile() {
  const {
    images
  } = useEdgeConfigWidget(WidgetId.ThankYouContent);

  /**
   * @note
   * https://nextjs.org/docs/app/api-reference/functions/generate-metadata#resource-hints
   *
   * We can also specify these additional options:
   * - imageSizes
   * - imageSrcSet
   */
  ReactDOM.preload(images.background.src, {
    as: 'image',
    fetchPriority: 'high'
  });
  return <Styled.Wrapper $backgroundImage={images.background.src}>
      <Styled.Header>
        <Styled.Logo src={images.logo.src} alt="Plarium logo" width={LOGO_WIDTH} height={LOGO_HEIGHT} />
        <CopyableTextComponent />
      </Styled.Header>
    </Styled.Wrapper>;
});